import pretend from './modules/pretend'
export default pretend
